// extracted by mini-css-extract-plugin
module.exports = {"container":"FormSkeleton_container__2W-i4"};